import { Component, OnInit } from '@angular/core';
import { IDasboard } from '../interface/dto';
import { ExamService } from '../services/exam-service.service';
import { environment as env } from 'src/environments/environment';
import { AuthService } from '../services/http-services/authservice.service';
import { Util } from '../services/Util';
import { ProctorService } from '../services/proctor.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  dashData: IDasboard = {
    examCount: 0,
    writtenCount: 0,
    ongoingCount: 0,
    candidateCount: 0,
    todaysExamination: [],
    upcomingExaminations: [],
    concludedExaminations: [],
    pendingCount: 0
  };
  constructor(private examService: ExamService, private authService: AuthService, private proctorService: ProctorService) { }

  async ngOnInit() {
    this.authService.setCookie(env.clientInformationStore, null);
    await this.examService.getDashboardData().then((res: any) => {
      if (res) {
        this.dashData = res;
        this.setOperationPermisstions(res.permissions);
      }
    });
    if (!this.authService.getCookie('authToken')) {
      await this.proctorService.getProctorToken().then((u: any) => {
        this.authService.setCookie('authToken', u.data);
        this.authService.setCookie('authCompany', this.authService.user.company);
      });
    }

  }

  GetDate(event: any) {
    let date = new Date(event);
    return Util.getUserLocalDateTimeString(date, this.authService.user.timezoneOffset);
  }

  async setOperationPermisstions(permissions) {
    this.authService.setPermissions(permissions);
  }
}
